import React, { useState } from "react";

export default function Checkout() {
  const [encRequest, setEncRequest] = useState("");
  const [accessCode, setAccessCode] = useState("");

  const handleCheckout = async (e) => {
    e.preventDefault();

    const formData = {
      order_id: "ORD12345",
      amount: "100.00",
      currency: "INR",
      billing_name: "John Doe",
      billing_email: "john@example.com",
      billing_tel: "9876543210",
      redirect_url: "https://your-site.com/paymentRedirect",
      cancel_url: "https://your-site.com/paymentRedirect",
    };

    const res = await fetch("http://localhost:5000/create-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await res.json();
    setEncRequest(data.encRequest);
    setAccessCode(data.accessCode);

    // Auto-submit like JSP
    setTimeout(() => {
      document.getElementById("ccavenueForm").submit();
    }, 500);
  };

  return (
    <div>
      <form onSubmit={handleCheckout}>
        <button type="submit">Pay Now</button>
      </form>

      {/* Hidden form that mimics JSP redirect */}
      <form
        id="ccavenueForm"
        method="post"
        action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
      >
        <input type="hidden" name="encRequest" value={encRequest} />
        <input type="hidden" name="access_code" value={accessCode} />
      </form>
    </div>
  );
}
